import React from 'react';
import { Flex, Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

/**
 * Currency selector — a segmented control: the chosen currency sits raised on
 * a sunken track.
 */
export default function DashboardCurrencyTabs({ currencies, selected, onChange }) {
  const { t } = useTranslation('dashboard');
  return (
    <Flex
      role="group"
      aria-label={t('currencyTabs.label')}
      gap="2px"
      p="2px"
      align="center"
      bg="redesign.bg.sunken"
      border="1px solid"
      borderColor="redesign.border"
      borderRadius="8px"
    >
      {['all', ...currencies].map(c => (
        <Button
          key={c}
          size="sm"
          variant="ghost"
          aria-pressed={selected === c}
          bg={selected === c ? 'redesign.bg.raised' : 'transparent'}
          color={selected === c ? 'redesign.heading' : 'redesign.text.muted'}
          boxShadow={selected === c ? '0 1px 2px rgba(16, 24, 40, 0.10)' : 'none'}
          _dark={{ boxShadow: 'none' }}
          fontWeight={500}
          _hover={{ color: 'redesign.heading' }}
          _active={{ bg: 'redesign.bg.raised' }}
          onClick={() => onChange(c)}
          px={2.5}
          fontSize={{ base: 'xs', md: 'sm' }}
          height="24px"
          minW="auto"
          borderRadius="6px"
        >
          {c === 'all' ? t('currencyTabs.all') : c}
        </Button>
      ))}
    </Flex>
  );
}
